import { levelMapScene } from "@kit/map";
import { track } from "@kit/telemetry";
import { meta } from "./meta";
import { KacisScene } from "./KacisScene";

const KacisMap = levelMapScene({
  id: "kacis",
  gameScene: "kacis",
  title: { tr: "Kaçış", en: "Escape" },
  accent: 0xff595e,
  firstTheme: 4,
  track,
  describe: (_n, lang) => (lang === "tr" ? "Jöleleri kapılardan çıkar · gizli kelimenin sırasıyla 3 yıldız" : "Get the jellies out · escape in the hidden word's order for 3 stars"),
});

/** Embeddable game contract (docs/design/platform.md): the shell starts these scenes in its own Phaser instance. */
export const game = { meta, scenes: [KacisMap, KacisScene] };
